<template>
  <b-card>
    <b-row
      align-h="end"
      class="mr-0"
      style="gap: 1rem;"
    >
      <download-em-excel
        :filtro="filtroAtual"
        tipo="CNDs Estadual"
        :api="apiEstadual"
        :get-info-extra="montarDto"
      />
      <download-em-lote
        tipo-arquivo="todas as CND's Estaduais"
        tipo="CND Estadual"
        :filtro="filtroAtual.filtroBy"
        :palavras-filtro="palavrasPersonalizadas"
        @baixar-lote="baixarEmLote"
      />
    </b-row>
    <cnd-estadual-list
      ref="cndEstadualList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="true"
      :filtro-extra-custom="1"
      :tem-limpar-filtros="true"
      @limpar-filtros="limparFiltro"
    >
      <template slot="filtro-extra">
        <filtro-rapido
          ref="filtroRapido"
          :filtros="filtrosEstados"
          filtro-nome="UF"
          @selecionado="$refs.cndEstadualList.aplicarFiltroRapido({...$event, colunas: ['Estado'] }, false)"
        />
      </template>
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <cnd-situacao
          v-if="props.column.field === 'situacao'"
          :value="props.row[props.column.field]"
          :descricao="props.row['situacaoDesc']"
        />
        <span
          v-if="props.column.field === 'razaoSocial'"
          @click.stop="$refs[`acoes${props.row.id}`].abrirArquivo(props.row)"
        >
          {{ props.formattedRow[props.column.field] }}
        </span>
        <span
          v-if="props.column.field === 'proximaConsulta'"
          v-b-tooltip.hover
          :title="props.row[props.column.field] === '-' && props.row[`situacaoDesc`] === 'Motivo' ? 'Aguardando dados da Inscrição Estadual no cadastro da empresa' : ''"
        >
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <cnd-acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          :api="apiEstadual"
          :tipo-cnd="tipoCnd"
          :filtros-rapidos="filtrosRapidos"
          sub-rotinas="ESTADUAL"
          tipo="estadual"
          data-liberacao-historico="Agosto de 2025"
        />
      </template>
    </cnd-estadual-list>
  </b-card>
</template>

<script>
import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import siglaEstados from '@/app/siglas-estados'
import colunas from './shared/components/colunas'
import api from './shared/services/api'

export default {
  name: 'CndEstadualVisualizacao',
  components: {
    CndEstadualList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    CndAcoes: () => import('@/app/shared/components/cnd-acoes/CndAcoes.vue'),
    FiltroRapido: () => import('@pilar/components/visualizacao-base/components/filtro-rapido/FiltroRapido.vue'),
    CndSituacao: () => import('@/app/shared/components/cnd-situacao/CndSituacao.vue'),
    DownloadEmLote: () => import('@app/download-lote/DownloadEmLote.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
  },
  data() {
    return {
      apiEstadual: api,
      tipoCnd: 'estadual',
      filtrosEstados: siglaEstados,
      botoesOption: null,
      linha: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social, Consultado em, Data de validade e próxima consulta',
        acaoClass: 'col-td-acao-4',
        disabledCheckbox: false,
      },
      filtros: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial', 'UltimaConsulta', 'DataValidade', 'ProximaConsulta'], valor: null }],
      filtrosRapidos: [
        {
          id: 'Regular',
          colunas: ['Situacao'],
          label: 'Regulares',
          valor: '1,2',
        },
        {
          id: 'Irregular',
          colunas: ['Situacao'],
          label: 'Irregulares',
          valor: '3',
        },
        {
          id: 'Motivo',
          colunas: ['Situacao'],
          label: 'Motivo não geração',
          valor: '4,7',
        },
        {
          id: 'BuscandoDado',
          colunas: ['Situacao'],
          label: 'Buscando dados',
          valor: '7',
        },
        {
          id: 'PossuiObservacao',
          colunas: ['PossuiObservacao'],
          label: 'Possui observação',
          valor: true,
        },
      ],
      criando: true,
      filtroAtual: {},
    }
  },
  computed: {
    palavrasPersonalizadas: {
      get() {
        const estados = siglaEstados.map(map => map.label)
        return [['Regulares', 'Irregulares', 'Motivo'], [...estados]]
      },
    },
  },
  created() {
    this.visualizacao.colunas = colunas
    this.visualizacao.evento = this.carregar
    this.visualizacao.allpaged = this.allPaged
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro).then(async response => {
        if (response.data && response.data.valores && response.data.valores.length > 0) {
          const ids = response.data.valores.map(i => i.id)
          const tipoRotinaId = 4 // CndEstadual
          try {
            const statusResp = await envioHistoricoApi.obterStatus(tipoRotinaId, ids)
            const statusMap = {}
            if (statusResp.data) {
              statusResp.data.forEach(s => { statusMap[s.idRegistro] = s })
            }
            response.data.valores.forEach(item => {
              const status = statusMap[item.id]
              if (status) {
                this.$set(item, 'whatsappEnviado', status.whatsappEnviado)
                this.$set(item, 'emailEnviado', status.emailEnviado)
              }
            })
          } catch (err) {
            this.$erro(err)
          }
        }
        return response
      })
    },
    allPaged(filtro) {
      return api.getTodasLinhas(filtro)
    },
    getColorTag(value) {
      if (value === 'Regular') {
        return 'light-success'
      }
      return value === 'Irregular' ? 'light-danger' : 'light-primary'
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.cndEstadualList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.cndEstadualList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
    baixarEmLote(evt) {
      const empresas = this.$refs.cndEstadualList.linhaSelecionada
      this.filtroAtual.empresasSelecionadas = !empresas ? [] : empresas
      api.baixaEmLote(this.filtroAtual, evt)
    },
    limparFiltro() {
      this.$refs.filtroRapido.selecionado = null
    },
    montarDto() {
      if (this.$refs.cndEstadualList) {
        const empresas = this.$refs.cndEstadualList.linhaSelecionada
        this.filtroAtual.empresasSelecionadas = !empresas ? [] : empresas
        return this.filtroAtual
      }
      return undefined
    },
  },
}
</script>
